import React, { FunctionComponent, memo, ReactElement } from 'react'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import LinkProps from '../../../../Link/LinkProps'

export type PodcastIconTypes =
    | 'podcast-itunes-active'
    | 'podcast-deezer-active'
    | 'podcast-apple-active'
    | 'podcast-spotify-active'

export type PodcastPlatformIconProps = {
    /** the name of the fontello icon */
    podcastIconType: PodcastIconTypes
    /** href string to navigate to the provided url (web only) */
    href?: string
    /**
     * callback function triggered when icon is pressed
     *
     * @TJS-type function
     */
    onPress: () => void
} & LinkProps

const PodcastPlatformIcon: FunctionComponent<PodcastPlatformIconProps> = ({
    podcastIconType,
    href,
    onPress,
    webRel,
}): ReactElement => (
    <Grid marginLeft={5} noExpand minWidth={24}>
        <Touchable onPress={onPress} href={href} webRel={webRel}>
            <FontelloIcon name={podcastIconType} fontSize={24} color="onyx-3" />
        </Touchable>
    </Grid>
)

export default memo(PodcastPlatformIcon)
